import React, { useContext, useState } from "react"

import { Grid } from "@material-ui/core"

import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import PictureCardWithZoom from "Components/UI/Atoms/PictureCard/PictureCardWithZoom"
import { interfaces } from "service/interfaces"
import { FormContext } from "Components/Hooks/ContextForm"
import img1 from "../Assets/1.jpg"
import img2 from "../Assets/2.jpg"
import img3 from "../Assets/3.jpg"
import img4 from "../Assets/4.jpg"
import img5 from "../Assets/5.jpg"
import img6 from "../Assets/6.jpg"

import { EditContext } from "Components/Hooks/ContextEdit"

import { styles } from "../MainPhotos/styles" 
import Upload from "./Upload"
import Delete from "./Delete"
import DialogUpload from "./UploadAdditional"
import CustomButton from "Components/UI/Atoms/CustomButton"
import DeleteAdditional from "./DeleteAdditional"

const ReviewPhotos = () => {
  const { formEdit } = useContext(FormContext)
  const [edit] = useContext(EditContext)
  const createDismissableSnackbar = useCustomSnackbar()

  const [dataActions, setDataActions] = useState({})
  const [change, setChange] = useState()
  const [loading, setLoading] = useState(false)
  const classes = styles()

  const [change1, setChange1] = useState([])
  const [dataActions1, setDataActions1] = useState({})

  function handleOpenDelete(data, index, openRemove) {
    setDataActions1({
      data: data,
      index: index,
      openRemove: openRemove,
      id: formEdit.vehicle.id,
    })
  }
  function handleOpenUpload() {
    setDataActions1({
      openUpload: true,
      id: formEdit.vehicle.id,
    })
  }

  function handleChange1(e) {
    e.preventDefault()
    let prevData = [...change1]
    let files = e.target.files
    for (let i = 0; i < files.length; i++) {
      prevData[i] = files[i]
    }
    setChange1(prevData)
  }
  function handleCloseActions1() {
    setChange1([])
    setDataActions1({
      openUpload: false,
      openRemove: false,
      id: null,
    })
  }

  function handleAdd(arr) {
    for (let i = 0; i < arr.length; i++) {
      let imgUp = URL.createObjectURL(arr[i])
      formEdit.revisionExtraPhotos.push(imgUp)
    }
  }

  function handleOpenActions(data, index, openRemove, openUpload) {
    setDataActions({
      data: data,
      index: index,
      openRemove: openRemove,
      openUpload: openUpload,
      id: formEdit.vehicle.id,
    })
  }
  function handleChange(e) {
    e.preventDefault()
    let img = e.target.files[0]
    setChange({
      ...change,
      file: img,
    })
  }

  function handleCloseActions() {
    setChange()
    setDataActions({
      open: false,
      id: null,
    })
  }
  function handleReplace(index, arr) {
    let imgUp = URL.createObjectURL(arr)
    formEdit.revisionPhotos[index] = imgUp
  }
  function handleDeleteContext(index) {
    let position = index - 1
    formEdit.revisionPhotos[position] = ""
  }

  function handleDeleteContext1(index) {
    let delet = index - 1
    formEdit.revisionExtraPhotos.splice(delet, 1)
  }

  async function handleSubmitDelete(arr, index) {
    setLoading(true)
    if (arr !== "" && arr !== undefined) {
      await interfaces.vehicleInterface
        .deleteFile("revision", index, formEdit.vehicle.dominio)
        .then((res) => {
          createDismissableSnackbar(res.data, {
            variant: "success",
          })
          handleDeleteContext(index)
          handleCloseActions()
        })
        .catch((error) => {
          createDismissableSnackbar(error.response.data.data, {
            variant: "error",
          })
          handleCloseActions()
        })
    } else {
      createDismissableSnackbar("Esta foto no existe! ", {
        variant: "error",
      })
      handleCloseActions()
    }
    setLoading(false)
  }

  async function handleSubmitUpload(value, index) {
    setLoading(true)
    await interfaces.vehicleInterface
      .uploadPhoto(value, index + 1, formEdit.vehicle.dominio, "revision")
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        handleReplace(index, value)
        handleCloseActions()
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: "error",
        })
        handleCloseActions()
      })
    setLoading(false)
  }

  async function handleDeleteAdditional(arr, index) {
    setLoading(true)
    if (arr !== "" && arr !== undefined) {
        await interfaces.vehicleInterface
          .deleteFile("revisionextras", index, formEdit.vehicle.dominio)
          .then((res) => {
            createDismissableSnackbar(res.data, {
              variant: "success",
            })
            handleDeleteContext1(index)
            handleCloseActions1()
          })
          .catch((error) => {
            createDismissableSnackbar(error.response.data.data, {
              variant: "error",
            })
            handleCloseActions1()
          })
      } else {
        createDismissableSnackbar("Esta foto no existe! ", {
          variant: "error",
        })
        handleCloseActions1()
      }
    setLoading(false)
  }

  async function handleSubmitAdditional(value) {
    setLoading(true)
    let index = formEdit.revisionExtraPhotos.length + 1
    await interfaces.vehicleInterface
      .uploadAdditionalPhotosRevision(value, index, formEdit.vehicle.dominio)
      .then((res) => {
        createDismissableSnackbar(`${res.data.data}`, {
          variant: "success",
        })
        handleAdd(value)
        handleCloseActions1()
      })
      .catch(() => {
        createDismissableSnackbar("Error", {
          variant: "error",
        })
        handleCloseActions1()
      })
    setLoading(false)
  }

  const titles = [
    {
      id: 1,
      name: `Frente${extractDateFromUrl(0) ? " - " + extractDateFromUrl(0) : ""}`,
      img: !formEdit.revisionPhotos[0] ? img1 : imageUrl(0),
    },
    {
      id: 2,
      name: `Izquierda${extractDateFromUrl(1) ? " - " + extractDateFromUrl(1) : ""}`,
      img: !formEdit.revisionPhotos[1] ? img2 : imageUrl(1),
    },
    {
      id: 3,
      name: `Atrás${extractDateFromUrl(2) ? " - " + extractDateFromUrl(2) : ""}`,
      img: !formEdit.revisionPhotos[2] ? img3 :  imageUrl(2),
    },
    {
      id: 4,
      name: `Derecha${extractDateFromUrl(3) ? " - " + extractDateFromUrl(3) : ""}`,
      img: !formEdit.revisionPhotos[3] ? img4 :  imageUrl(3),
    },
    {
      id: 5,
      name: `Motor${extractDateFromUrl(4) ? " - " + extractDateFromUrl(4) : ""}`,
      img: !formEdit.revisionPhotos[4] ? img5 :  imageUrl(4),
    },
    {
      id: 6,
      name: `Interior${extractDateFromUrl(5) ? " - " + extractDateFromUrl(5) : ""}`,
      img: !formEdit.revisionPhotos[5] ? img6 : imageUrl(5),
    },
  ]

  const swipes = formEdit.revisionExtraPhotos.map((item, index) => ({
    id: index,
    img: extraImageUrl(index),
  }))

  function imageUrl(index) {
    return formEdit.revisionPhotos[index]?.replace(/(\/revision\/\d+)\/[^/]+\.webp$/, "$1.webp")
  }

  function extractDateFromUrl(index) {
    const fecha = formEdit.revisionPhotos[index]?.match(/\/(\d{2}-\d{2}-\d{4})\.webp$/)?.[1]
    const fechaFormateada = fecha?.replace(/-/g, "/")

    return fechaFormateada
  }

  function extraImageUrl(index) {
    return formEdit.revisionExtraPhotos[index]?.replace(/(\/revisionextras\/\d+)\/[^/]+\.webp$/, "$1.webp")
  }

  function extractExtraDateFromUrl(index) {
    const fecha = formEdit.revisionExtraPhotos[index]?.match(/\/(\d{2}-\d{2}-\d{4})\.webp$/)?.[1]
    return fecha?.replace(/-/g, "/")
  }

  return (
    <div className={classes.root}>
      <Grid container alignContent="center" justify="center" spacing={2}>
        {titles.map((item, index) => (
          <Grid item xs={12} xl={4} sm={6} md={4}>
            <PictureCardWithZoom
              img={
                !formEdit.revisionPhotos[index] 
                  ? item.img
                  : imageUrl(index)
              }
              editIcon
              alt={item.name}
              txt={item.name}
              edit={edit}
              handleDelete={() =>
                handleOpenActions(
                  formEdit.revisionPhotos[index] === ""
                    ? item.img
                    : formEdit.revisionPhotos[index],
                  index + 1,
                  true,
                  false
                )
              }
              handleUpload={() => handleOpenActions(item, index, false, true)}
              dataUpload={item}
              index={index + 1}
              id={formEdit.vehicle.id}
              swipes={titles}
            />
          </Grid>
        ))}

       <Grid container alignContent="center" justify="center" spacing={2}>
         {edit ? (
           <Grid item xs={12} xl={12} sm={12} md={12} className={classes.container} >
            <CustomButton
              onClick={() => handleOpenUpload()}
              text={"Agregar fotografías adicionales"}
              className={classes.cardSelectImg}
              size={"small"}
            />
           </Grid>
         ) : null}
         {formEdit.revisionExtraPhotos
            ?.filter((item) => item !== "")
            .map((item, index) => (
            <Grid item xs={12} xl={4} sm={6} md={4} className={classes.root2}>
             <PictureCardWithZoom
                img={extraImageUrl(index)}
                edit={edit}
                txt={`Adicional ${index + 1} - ${extractExtraDateFromUrl(index) || ""}`}
                title={`Adicional ${index + 1} - ${extractExtraDateFromUrl(index) || ""}`}
                index={index + 1}
                swipes={swipes}
                handleDelete={() => handleOpenDelete(item, index + 1, true)}
             />
           </Grid>
         ))}
       </Grid>       

        <Delete
          data={dataActions}
          open={dataActions.openRemove}
          handleClose={handleCloseActions}
          onSubmit={handleSubmitDelete}
          loading={loading}
        />

        <Upload
          handleChange={handleChange}
          change={change}
          data={dataActions}
          onSubmit={handleSubmitUpload}
          handleClose={handleCloseActions}
          open={dataActions.openUpload}
          loading={loading}
        /> 

        <DialogUpload
          open={dataActions1.openUpload}
          handleClose={handleCloseActions1}
          onSubmit={handleSubmitAdditional}
          handleChange={handleChange1}
          change={change1}
          loading={loading}
        />      

        <DeleteAdditional
          data={dataActions1}
          open={dataActions1.openRemove}
          handleClose={handleCloseActions1}
          onSubmit={handleDeleteAdditional}
          loading={loading}
        />  
        
      </Grid>
    </div>
  )
}
export default ReviewPhotos